import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField, MenuItem } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { cpf as cpfValidator } from 'cpf-cnpj-validator';
import { UF } from '../../../../enums/uf';
import { useStyles } from './style';

interface PersonalDataStepProps {
  control: any;
  errors: any;
}

const PersonalDataStep: React.FC<PersonalDataStepProps> = ({ control, errors }) => {
  const classes = useStyles();
  return (
    <>
      <Controller
        name="cpf"
        control={control}
        rules={{
          required: 'CPF é obrigatório',
          validate: (value) =>
            cpfValidator.isValid(value.replace(/[^\d]+/g, '')) || 'CPF inválido',
        }}
        render={({ field }) => (
          <InputMask mask="999.999.999-99" maskChar="" {...field}>
            {(inputProps: any) => (
              <TextField
                {...inputProps}
                label="CPF"
                variant="outlined"
                fullWidth
                className={classes.textField}
                error={!!errors.cpf}
                helperText={errors.cpf ? errors.cpf.message : ''}
                required
              />
            )}
          </InputMask>
        )}
      />
      <Controller
        name="birthDate"
        control={control}
        rules={{ required: 'Data de nascimento é obrigatória' }}
        render={({ field }) => (
          <TextField
            {...field}
            label="Data de Nascimento"
            variant="outlined"
            type="date"
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            error={!!errors.birthDate}
            helperText={errors.birthDate ? errors.birthDate.message : ''}
            required
          />
        )}
      />
      <Controller
        name="email"
        control={control}
        rules={{
          required: 'O e-mail é obrigatório',
          pattern: {
            value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
            message: 'Formato de e-mail não válido',
          },
        }}
        render={({ field }) => (
          <TextField
            {...field}
            label="E-mail"
            variant="outlined"
            type="email"
            fullWidth
            className={classes.textField}
            error={!!errors.email}
            helperText={errors.email ? errors.email.message : ''}
            required
          />
        )}
      />
      <Controller
        name="name"
        control={control}
        rules={{ required: 'Nome completo é obrigatório' }}
        render={({ field }) => (
          <TextField
            {...field}
            label="Nome Completo"
            variant="outlined"
            fullWidth
            className={classes.textField}
            error={!!errors.name}
            helperText={errors.name ? errors.name.message : ''}
            required
          />
        )}
      />
      <Controller
        name="gender"
        control={control}
        rules={{ required: 'Gênero é obrigatório' }}
        render={({ field }) => (
          <TextField
            {...field}
            select
            label="Sexo"
            variant="outlined"
            fullWidth
            className={classes.textField}
            error={!!errors.gender}
            helperText={errors.gender ? errors.gender.message : ''}
            required
          >
            <MenuItem value="">Selecione</MenuItem>
            <MenuItem value="MALE">Masculino</MenuItem>
            <MenuItem value="FEMALE">Feminino</MenuItem>
            <MenuItem value="NOT_INFORMED">Prefiro não informar</MenuItem>
          </TextField>
        )}
      />
      <Controller
        name="phone"
        control={control}
        rules={{ required: 'Celular é obrigatório' }}
        render={({ field }) => (
          <InputMask mask="(99) 99999-9999" maskChar="" {...field}>
            {(inputProps: any) => (
              <TextField
                {...inputProps}
                label="Celular"
                variant="outlined"
                fullWidth
                className={classes.textField}
                error={!!errors.phone}
                helperText={errors.phone ? errors.phone.message : ''}
                required
              />
            )}
          </InputMask>
        )}
      />
      <Controller
        name="medicine"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Medicamento"
            variant="outlined"
            fullWidth
            disabled
            defaultValue="Ajovy"
            className={classes.textField}
            error={!!errors.doctorCrm}
            helperText={errors.doctorCrm ? errors.doctorCrm.message : ''}
            required
          />
        )}
      />
      <Controller
        name="doctorCrm"
        control={control}
        rules={{ required: 'Número CRM é obrigatório' }}
        render={({ field }) => (
          <TextField
            {...field}
            label="CRM do Médico"
            variant="outlined"
            fullWidth
            className={classes.textField}
            error={!!errors.doctorCrm}
            helperText={errors.doctorCrm ? errors.doctorCrm.message : ''}
            required
          />
        )}
      />
      <Controller
        name="doctorUf"
        control={control}
        rules={{ required: 'UF do CRM é obrigatório' }}
        render={({ field }) => (
          <TextField
            {...field}
            select
            label="UF do CRM"
            variant="outlined"
            fullWidth
            className={classes.textField}
            error={!!errors.doctorUf}
            helperText={errors.doctorUf ? errors.doctorUf.message : ''}
            required
          >
            {Object.values(UF).map((uf) => (
              <MenuItem key={uf} value={uf}>
                {uf}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
      <Controller
        name="doctorName"
        control={control}
        rules={{ required: 'Nome do Profissional é obrigatório' }}
        render={({ field }) => (
          <TextField
            {...field}
            label="Nome do Profissional"
            variant="outlined"
            fullWidth
            className={classes.textField}
            error={!!errors.doctorName}
            helperText={errors.doctorName ? errors.doctorName.message : ''}
            required
          />
        )}
      />
    </>
  );
};

export default PersonalDataStep;
